export const environment = {
    production: true,
    deploy: 'aws'
};
